module.exports = __webpack_public_path__ + "img/dry-dock.d8a7de6b.png";